import { Component, AfterViewInit, Input } from '@angular/core';
import * as Chart from 'chart.js';
import { ApiService } from './../services/api.service';
import { ResponseService } from './../services/response.service';
import { Transfer } from './../interfaces/transfer/transfer.model';

@Component({
    selector: 'server-transfer',
    templateUrl: './server-transfer.component.html'
}) export class ServerTransferComponent implements AfterViewInit {
    @Input() serviceID: Number;
    public transfers: Array<Transfer>;
    // Zmienna mówiąca o pobieraniu danych
    public loadingServerData: Boolean = true;
    public transferForModal: Transfer;

    bytesList = [
        {name: 'Bajtów', divided: 1, symbol: 'B'},
        {name: 'Kilobajtów', divided: 1024, symbol: 'KB'},
        {name: 'Megabajtów', divided: 1048576, symbol: 'MB'},
        {name: 'Gigabajtów', divided: 1073741824, symbol: 'GB'},
        {name: 'Terabajtów', divided: 1099511627776, symbol: 'TB'},
      ];
    
    selectedBytesList = this.bytesList[0];

    formatBytes(a,b){if(0==a)return"0 Bytes";var c=1024,d=b||2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],f=Math.floor(Math.log(a)/Math.log(c));return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f]}

    formatBytesWithUnlimited(a,b){if(0==a)return"Bez limitu";var c=1024,d=b||2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],f=Math.floor(Math.log(a)/Math.log(c));return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f]}
  
    parseFloatValues(a, b){ return parseFloat(a.toFixed(b));}

    ngAfterViewInit(){
        this.getServerInfo(this.serviceID);
    }
    constructor(
        private apiService: ApiService,
        private responseService: ResponseService,
    ){}
    private getServerInfo(serviceId: Number): void {
        this.loadingServerData = true;
        this.apiService.get('/service/' + serviceId + '/transfer').subscribe(
          (response) => {
            const transfers = this.responseService.success(false, response, 'transfers');
            this.transfers = transfers;
            this.loadingServerData = false;
          },
          (error) => {}
          );
    }

    showDetailsTransfer(transfer: Transfer){
        this.transferForModal = transfer;
    }

    reloadData(){
    }
}


// WEBPACK FOOTER //
// ./src/app/server/server-transfer.component.ts